import {
    ActivityRecordType,
    ReferenceBusinessId,
    ReferenceContactId,
} from "@sp-crm/core";
import type { AppRouter } from "@sp-crm/server/rpc";
import type { inferProcedureOutput } from "@trpc/server";

export type CalendarEventDto = inferProcedureOutput<
    AppRouter["calendarEvents"]["create"]
>;

interface VisitParentBase {
    name: string;
    address: string | null;
}

export type VisitParent =
    | ({ kind: "contact"; id: ReferenceContactId } & VisitParentBase)
    | ({ kind: "organization"; id: ReferenceBusinessId } & VisitParentBase);

export type VisitParentKind = VisitParent["kind"];

export const activityRecordTypeForVisitParentKind = (
    kind: VisitParentKind,
): ActivityRecordType => (kind === "contact" ? "referenceContact" : "referenceBusiness");

interface VisitParentIds {
    parentId?: string | null;
    businessId?: string | null;
}

export const visitParentKind = (visit: VisitParentIds): VisitParentKind =>
    visit.businessId !== null &&
    visit.businessId !== undefined &&
    visit.businessId === visit.parentId
        ? "organization"
        : "contact";
